import script from "./SequenceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SequenceCard.vue?vue&type=script&setup=true&lang=js"

import "./SequenceCard.vue?vue&type=style&index=0&id=5f64b512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f64b512"]])

export default __exports__